var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "el-form-title",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "故事名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入需要查询的故事名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "故事分类" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "请选择需要查询的故事类型",
                    "value-key": "code",
                  },
                  model: {
                    value: _vm.storyType,
                    callback: function ($$v) {
                      _vm.storyType = $$v
                    },
                    expression: "storyType",
                  },
                },
                _vm._l(_vm.typeList, function (type) {
                  return _c("el-option", {
                    key: type.code,
                    attrs: { label: type.value, value: type },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("el-form-item", [
            _c(
              "div",
              { staticClass: "align-right" },
              [
                _c("el-button", { on: { click: _vm.fetchData } }, [
                  _vm._v("查询"),
                ]),
                _c("el-button", { on: { click: _vm.addStory } }, [
                  _vm._v("新增"),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "48",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "故事名称",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "created_at",
              label: "创建人",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.createdBy))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "created_at",
              label: "更新人",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.updatedBy))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "created_at",
              label: "故事分类",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.storyType))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "created_at",
              label: "创建时间",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.createTime))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "created_at",
              label: "更新时间",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.updateTime))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "描述", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.description || "暂无")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "220",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.delItem(scope.row._id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editItem(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }